import axios from 'axios';
import {pickBy, reduce} from 'lodash';
import Analytics from '../../../../shared/utility/analytics';
import {config, theme, lead_form} from "../../config";
import {ConfigState, LeadFormState } from "../../contract/setting";
import { Theme } from '@emotion/react';

export interface SettingsPayload {
  data: {[key: string]: any};
  lead_form: LeadFormState;
  settings: ConfigState;
  theme: Theme;
}

const getSettings = (): Promise<SettingsPayload> => {
  const payload: SettingsPayload = {
    data: {},
    lead_form,
    settings: config,
    theme,
  };

  return axios({
    url: '/news/tool-settings',
  }).then(({data}): SettingsPayload => {
    if (!data) return;

    const {
      // theme
      highlightColor,
      primaryColor,
      secondaryColor,
      backgroundColor,
      primaryFontColor,
      secondaryFontColor,
      successColor,
      failureColor,
      buttonBorderRadius,
      thumbnailBorderRadius,
      cardColor,
      borderColor,

      // settings
      showLeadButton,
      googleTagManagerId,
      uaCode,
      template,
      alt_source_environment,
      news_widgets_enabled,
      ...settings
    } = data;

    payload.data = {
      ...payload.data,
      googleTagManagerId,
      uaCode
    };
    payload.theme = {
      ...payload.theme,
      highlightColor,
      primaryColor,
      secondaryColor,
      backgroundColor,
      primaryFontColor,
      secondaryFontColor,
      successColor,
      failureColor,
      buttonBorderRadius,
      thumbnailBorderRadius,
      cardColor,
      borderColor,
    };
    payload.lead_form = {
      ...payload.lead_form,
      ...pickBy(settings, (value, key) => key.startsWith('lead')),
      showLeadButton,
    }
    payload.settings = {
      ...payload.settings,
      ...pickBy(settings, (value, key) => !key.startsWith('lead')),
      template,
      environment: alt_source_environment,
      widgets: reduce(news_widgets_enabled, (result, enabled, widget) => {
        if (enabled) result.push(widget);

        return result;
      }, [])
    };

    Analytics.init(...['G-4JRE66022L', uaCode ?? null].filter(a => !!a));

    return payload;
  });
};

export default getSettings;
